declare global {
  interface PromiseConstructor {
    delay (ms: number): Promise<unknown>;
  }
}
Promise.delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export { };
